import { ChevronDownIcon, Loader2Icon } from 'components/icons';

/**
 * Fixed-width trailing slot of a filter trigger: shows a spinner while the trigger's popup waits for
 * its options, else the applied-filter count when there is one, the chevron otherwise. Every state
 * occupies the same box so the trigger width never shifts.
 */
export function FilterTriggerIndicator({ count, isLoading = false }: { count: number; isLoading?: boolean }) {
    return (
        <span className="flex size-[18px] flex-none items-center justify-center">
            {isLoading ? (
                <Loader2Icon className="text-grey-400 size-3.5 animate-spin" />
            ) : count > 0 ? (
                <span className="new:bg-primary-wash new:text-primary-ink new:text-caption flex size-full items-center justify-center rounded-full bg-[#EDF3ED] text-[10px] font-semibold text-[#4B7049] tabular-nums">
                    {count}
                </span>
            ) : (
                <ChevronDownIcon className="text-grey-400 size-3" />
            )}
        </span>
    );
}
